import { Controller } from "@hotwired/stimulus"

// Persists per-page settings to localStorage and restores them on page load.
// This ensures users don't lose their preferred page size when navigating or reloading.
export default class extends Controller {
  static values = {
    key: String,      // localStorage key (e.g., "searches-per-page")
    paramName: String // URL param name (e.g., "searches_per_page")
  }

  static targets = ["input"]

  connect() {
    this.restoreFromStorage()
  }

  // Save value to localStorage when changed
  save() {
    const value = this.inputTarget.value
    if (value && this.hasKeyValue) {
      localStorage.setItem(this.keyValue, value)
    }
  }

  // Restore value from localStorage on page load
  restoreFromStorage() {
    if (!this.hasKeyValue) return

    const savedValue = localStorage.getItem(this.keyValue)
    if (!savedValue) return

    const currentValue = this.inputTarget.value

    // If saved value differs from current, update and submit
    if (savedValue !== currentValue) {
      this.inputTarget.value = savedValue
      // Auto-submit the form to apply the saved value
      this.element.requestSubmit()
    }
  }
}
